<template>
  <div>
    <h3 class="facts__header">{{formattedHeaderText}}</h3>
    <ul class="facts">
      <li
        v-for="(fact, index) in facts"
        :key="index"
        class="facts__fact"
        :class="fact.stateAsClassName"
        @click="toggleAccordion(index)">
          <h3 class="facts__heading" >{{fact.heading}}</h3>
          <span class="facts__body">{{fact.content}}</span>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import {
  Component, Prop, Vue, Watch
} from 'vue-property-decorator';
import Accordion from '../../viewmodels/Accordion';
import { tokenService } from '../../services/TokenService';

@Component
export default class AccordionComponent extends Vue {
  @Prop({ default: 'Why should you use our free service?' })
  public headerText!: string;

  @Prop({
    default: () => [
      new Accordion(
        'Buying a New vehicleType?',
        "It's a complex business buying a new vehicleType. Choosing a model, engine, extras and trim levels isn't easy. That's where we come in. We can help you choose the exact vehicleType to suit your needs and driving requirements."
      ),
      new Accordion(
        'Find Great vehicleType Deals',
        'We deal with 100s of vehicleType Dealers across the UK to find you the best deals and offers. Our team can also let you know about any leasing and finance packages that may be available.'
      ),
      new Accordion(
        'Brochures, Test Drives and Quotes',
        "From start to finish we cover all your vehicleType leasing needs. As well as price quotes we can send you the latest brochures. We'll even arrange for a test drive to be booked with you so that you can experience your next car first hand."
      )
    ]
  })
  public accordion!: Accordion[];

  public get formattedHeaderText() {
    return tokenService.replaceToken(this.headerText);
  }

  public facts: Accordion[] = [];

  public toggleAccordion(index: number) {
    const accordionToChange = this.facts[index];
    accordionToChange.isCollapsed = !accordionToChange.isCollapsed;
  }

  public mounted() {
    this.facts = this.accordion.map(
      (a: Accordion) => new Accordion(tokenService.replaceToken(a.heading), tokenService.replaceToken(a.content))
    );
  }
}
</script>
